@let location = locationService.location$ | async;
<div class="dropdown location-indicator">
  <button
    #toggle
    type="button"
    class="btn btn-link location-toggle d-flex align-items-center"
    data-bs-toggle="dropdown"
    data-bs-auto-close="outside"
    aria-expanded="false"
    [attr.title]="location?.label ?? placeholder"
    i18n-aria-label="@@location.change"
    aria-label="Standort ändern"
    data-testid="location-indicator-toggle"
  >
    <fa-icon [icon]="faMapMarkerAlt" class="me-1"></fa-icon>
    <span class="location-text text-truncate" data-testid="location-indicator-label">{{ location?.label ?? placeholder }}</span>
  </button>
  <div class="dropdown-menu dropdown-menu-end p-3 location-menu" data-testid="location-indicator-menu">
    <h6 class="dropdown-header px-0 pt-0" i18n="@@location.heading">Standort für die Suche</h6>
    <app-location-picker (picked)="closeMenu()"></app-location-picker>
  </div>
</div>
